import { render, staticRenderFns } from "./Podlazie.vue?vue&type=template&id=782e3eda&scoped=true"
import script from "./Podlazie.vue?vue&type=script&lang=js"
export * from "./Podlazie.vue?vue&type=script&lang=js"
import style0 from "./Podlazie.vue?vue&type=style&index=0&id=782e3eda&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782e3eda",
  null
  
)

export default component.exports